import { injectIntl, intlShape } from 'react-intl';

import { xingConnect } from '@xingternal/xing-frame-provider';

import HorizontalNavigation from './HorizontalNavigation';
import selectNavigation from './selectors';

/*
 *  CONNECT WITH FRAME DATA
 */
const connectedNavigation = xingConnect(selectNavigation)(HorizontalNavigation);
connectedNavigation.propTypes = {
  intl: intlShape.isRequired,
};

const withIntl = injectIntl(connectedNavigation);

export default withIntl;
